import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi'

import { Button } from './Button'

interface PaginationProps {
  page: number
  totalCount: number
  pageQty: number
  onPageChange: (page: number) => Promise<void> | void
}

export function Pagination({ page, totalCount, pageQty, onPageChange }: PaginationProps) {
  const pages = Math.ceil(totalCount / pageQty) || 1

  return (
    <div className="flex items-center justify-between">
      <span className="text-sm">
        Total de {totalCount} item(s)
      </span>

      <div className="flex items-center gap-6 lg:gap-8">
        <div className="text-sm font-medium">Página {page} de {pages}</div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => onPageChange(1)}
            variant="outline"
            className="h-8 w-8 p-0 border-slate-500 text-slate-800 hover:bg-slate-200 hover:text-slate-800 disabled:border-slate-300 disabled:text-slate-300 hover:disabled:border-slate-300 hover:disabled:bg-transparent disabled:cursor-default"
            disabled={page === 1}
          >
            <FiChevronsLeft className="h-4 w-4" />
            <span className="sr-only">Primeira página</span>
          </Button>
          <Button
            onClick={() => onPageChange(page - 1)}
            variant="outline"
            className="h-8 w-8 p-0 border-slate-500 text-slate-800 hover:bg-slate-200 hover:text-slate-800 disabled:border-slate-300 disabled:text-slate-300 hover:disabled:border-slate-300 hover:disabled:bg-transparent disabled:cursor-default"
            disabled={page === 1}
          >
            <FiChevronLeft className="h-4 w-4" />
            <span className="sr-only">Página anterior</span>
          </Button>
          <Button
            onClick={() => onPageChange(page + 1)}
            variant="outline"
            className="h-8 w-8 p-0 border-slate-500 text-slate-800 hover:bg-slate-200 hover:text-slate-800 disabled:border-slate-300 disabled:text-slate-300 hover:disabled:border-slate-300 hover:disabled:bg-transparent disabled:cursor-default"
            disabled={page === pages}
          >
            <FiChevronRight className="h-4 w-4" />
            <span className="sr-only">Próxima página</span>
          </Button>
          <Button
            onClick={() => onPageChange(pages)}
            variant="outline"
            className="h-8 w-8 p-0 border-slate-500 text-slate-800 hover:bg-slate-200 hover:text-slate-800 disabled:border-slate-300 disabled:text-slate-300 hover:disabled:border-slate-300 hover:disabled:bg-transparent disabled:cursor-default"
            disabled={page === pages}
          >
            <FiChevronsRight className="h-4 w-4" />
            <span className="sr-only">Última página</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
